import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';
import { SamplesModule } from '@app/samples/samples.module';
import { SamplesComponent } from '@app/samples/samples.component';

const apiUrl = 'https://api-platform.portalstg2.mynexuscare.com';

export const environment: IEnvironment = {
  apiUrl,
  modules: [
    SamplesModule
  ],
  production: false,
  routes: [
    {
      path: ':tenantId/reporting',
      component: SamplesComponent,
      children: [
        // Add Sample pages here. Use the code below as a guide.
        // { path: 'reporting-component', component: SamplePageComponent, data: { title: 'REPORTING Component' } },
      ]
    },
  ],
  version: buildVersion as BuildVersion,
};
